import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

export const updateShowCancellation: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (show: boolean) => void
> = (set) => (show) =>
  set(
    (state) => {
      state.prescriptionAssistant.prescriptionPad.showCancellation = show;
    },
    false,
    'prescriptionPad/setShowCancellation',
  );
